const ExpenseDetails = ({utilization}) => {
  return <div>
            <div className="row pt-2 m-0">
            <div className="col-3 d-flex justify-content-between align-items-center">
                <span className="text-black-60 fs-12px">
                Expense Category
                </span>
            </div>
            <div className="col-3 d-flex justify-content-between align-items-center">
                <span className="text-black-60 fs-12px">
                &nbsp;
                </span>
            </div>
            <div className="col-3 d-flex justify-content-between align-items-center">
                <span className="text-black-60 fs-12px">
                &nbsp;
                </span>
            </div>
            <div className="col-3 d-flex justify-content-between align-items-center">
                <span className="text-black-60 fs-12px">
                &nbsp;
                </span>
            </div>
            </div>
            <div className="row pb-2 m-0">
            <div className="col-3 d-flex align-items-center">
                <span className="fs-14px fw-500">
                Vendor
                </span>
            </div>
            <div className="col-3 d-flex justify-content-between align-items-center">
                <span className="fs-14px fw-500">
                {Number(utilization?.current_fy_detail.vendor)}
                </span>
            </div>
            <div className="col-3 d-flex justify-content-between align-items-center">
                <span className="fs-14px fw-500">
                {Number(utilization?.prev_fy_detail.vendor)}
                </span>
            </div>
            <div className="col-3 d-flex justify-content-between align-items-center">
                <span className="fs-14px fw-500 text-success-100">
                {Number(utilization?.current_fy_detail.vendor) + Number(utilization?.prev_fy_detail.vendor)}
                </span>
            </div>
            </div>
            <div className="row pb-2 m-0">
            <div className="col-3 d-flex align-items-center">
                <span className="fs-14px fw-500">
                DBT/NACH
                </span>
            </div>
            <div className="col-3 d-flex justify-content-between align-items-center">
                <span className="fs-14px fw-500">
                {Number(utilization?.current_fy_detail.reimbursement)}
                </span>
            </div>
            <div className="col-3 d-flex justify-content-between align-items-center">
                <span className="fs-14px fw-500">
                {Number(utilization?.prev_fy_detail.reimbursement)}
                </span>
            </div>
            <div className="col-3 d-flex justify-content-between align-items-center">
                <span className="fs-14px fw-500 text-success-100">
                {Number(utilization?.current_fy_detail.reimbursement) + Number(utilization?.prev_fy_detail.reimbursement)}
                </span>
            </div>
            </div>
            <div className="row pb-2 m-0">
            <div className="col-3 d-flex align-items-center">
                <span className="fs-14px fw-500">
                Salary
                </span>
            </div>
            <div className="col-3 d-flex justify-content-between align-items-center">
                <span className="fs-14px fw-500">
                {Number(utilization?.current_fy_detail.salaries)}
                </span>
            </div>
            <div className="col-3 d-flex justify-content-between align-items-center">
                <span className="fs-14px fw-500">
                {Number(utilization?.prev_fy_detail.salaries)}
                </span>
            </div>
            <div className="col-3 d-flex justify-content-between align-items-center">
                <span className="fs-14px fw-500 text-success-100">
                {Number(utilization?.current_fy_detail.salaries) + Number(utilization?.prev_fy_detail.salaries)}
                </span>
            </div>
            </div>
            <div className="row pb-2 m-0">
            <div className="col-3 d-flex align-items-center">
                <span className="fs-14px fw-500">
                Budget Allocation
                </span>
            </div>
            <div className="col-3 d-flex justify-content-between align-items-center">
                <span className="fs-14px fw-500">
                {Number(utilization?.current_fy_detail.allocation)}
                </span>
            </div>
            <div className="col-3 d-flex justify-content-between align-items-center">
                <span className="fs-14px fw-500">
                {Number(utilization?.prev_fy_detail.allocation)}
                </span>
            </div>
            <div className="col-3 d-flex justify-content-between align-items-center">
                <span className="fs-14px fw-500 text-success-100">
                {Number(utilization?.current_fy_detail.allocation) + Number(utilization?.prev_fy_detail.allocation)}
                </span>
            </div>
            </div>
        </div>;
}

export default ExpenseDetails;